import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useExperienceWizard } from 'core/contexts/experienceWizard';
import { ExperienceInclusions, getIncludesIds, getTranslatedName, includes_policies } from '@utriper/core';
import { Field, useFormState } from 'react-final-form';
import { Add } from '@mui/icons-material';
import { Button, Grid2 } from '@mui/material';
import { Checklist } from '@utriper/core-ui';
import { Container, Label } from '../../../../styles';

const IncludesFormFields = ({ handleOpenAddForm }) => {
    const { i18n, t } = useTranslation();
    const translate = (key) => t(`experience_form.${key}`);
    const { values } = useFormState();
    const { customIncludes, customNotIncludes } = useExperienceWizard();

    const defaultIncludesOptions = useMemo(
        () =>
            getIncludesIds()
                .slice(0, 6)
                .map((id) => ({
                    id,
                    includesId: id,
                    label: getTranslatedName(includes_policies, id, i18n.language),
                    disabled: false,
                })),
        [i18n.language]
    );
    const includesOptions = useMemo(() => {
        const selectedNotIncludes = values?.notIncludes || [];
        const allOptions = [...defaultIncludesOptions, ...customIncludes];
        return allOptions.map((opt) => ({
            ...opt,
            disabled: opt.includesId ? selectedNotIncludes.includes(opt.id) : opt.disabled,
        }));
    }, [defaultIncludesOptions, customIncludes, values?.notIncludes]);

    const notIncludesOptions = useMemo(() => {
        const selectedIncludes = values?.includes || [];

        const allOptions = [...defaultIncludesOptions, ...customNotIncludes];
        return allOptions.map((opt) => ({
            ...opt,
            disabled: opt.includesId ? selectedIncludes.includes(opt.id) : opt.disabled,
        }));
    }, [defaultIncludesOptions, customNotIncludes, values?.includes]);

    return (
        <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
            <Container>
                <Label>{translate('includes')}</Label>
                <Field name="includes" component={Checklist} options={includesOptions} />
                <Button sx={{ color: 'var(--color-utriper-blue)', textTransform: 'none' }} variant="text" startIcon={<Add />} onClick={() => handleOpenAddForm(ExperienceInclusions.IDS.included)}>
                    {translate('add_new_option')}
                </Button>
            </Container>
            <Container>
                <Label>{translate('not_includes')}</Label>
                <Field name="notIncludes" component={Checklist} options={notIncludesOptions} />
                <Button sx={{ color: 'var(--color-utriper-blue)', textTransform: 'none' }} variant="text" startIcon={<Add />} onClick={() => handleOpenAddForm(ExperienceInclusions.IDS.notincluded)}>
                    {translate('add_new_option')}
                </Button>
            </Container>
        </Grid2>
    );
};

export default IncludesFormFields;
